import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { AuthProvider, useAuth } from "react-oidc-context";

import { setBearerProvider } from "./api/client";
import { oidcConfig } from "./auth/oidcConfig";
import { router } from "./router/router";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

// PRESERVED VERBATIM from pre-B.1.5 main.tsx: wires the OIDC access
// token into the API client's bearer getter. B.1.5 deliberately keeps
// this in the React tree (not in router.ts) because useAuth() needs
// the AuthProvider context. AuthGate has moved into routes/__root.tsx.
function BearerWiring({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  setBearerProvider(() => auth.user?.access_token);
  return <>{children}</>;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <QueryClientProvider client={queryClient}>
        <BearerWiring>
          <RouterProvider router={router} />
        </BearerWiring>
      </QueryClientProvider>
    </AuthProvider>
  </React.StrictMode>,
);
